function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { userMixin } from '@/mixins/user';
import ModalConfirm from '@/components/ModalConfirm';
import SidebarTreeBusinessTerms from '@/modules/business_glossary/components/SidebarTreeBusinessTerms';
import businessDomainService from '@/apps/data-platform/services/master_data/business_domain_service';
import businessSubdomainService from '@/apps/data-platform/services/master_data/business_subdomain_service';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import PaginationVue from '@/components/PaginationVue.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import FormBusinessTermsComponent from './components/FormBusinessTermsComponent.vue';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import tasks from '@/js/tasks';
import { NEW_BUSINESS_TERM, TAG_QUERIES, GA_EVENTS } from '@/js/constants';
export default {
  name: 'BusinessGlossaryPage',
  components: {
    ModalConfirm: ModalConfirm,
    SidebarTreeBusinessTerms: SidebarTreeBusinessTerms,
    PaginationVue: PaginationVue,
    DialogsComponent: DialogsComponent,
    FormBusinessTermsComponent: FormBusinessTermsComponent,
    DialogConfirmationComponent: DialogConfirmationComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  mixins: [userMixin],
  data: function data() {
    var undefinedName = 'Undefined';
    return {
      selectedTerms: [],
      currentTab: 0,
      UNDEFINED: undefinedName,
      kbusiness_termDel: '',
      kbusiness_termDel_name: '',
      kbusiness_termDel_domain: '',
      kbusiness_termDel_subdomain: '',
      baseSelectBusinessDomain: [{
        value: undefinedName,
        text: undefinedName
      }],
      baseSelectbusinessSubdomain: [{
        domain: undefinedName,
        value: undefinedName,
        text: undefinedName
      }],
      selectBusinessDomain: [],
      selectbusinessSubdomain: [],
      update_reg: NEW_BUSINESS_TERM,
      MODAL_NAME_ACCESS: 'business-term-tpl',
      MODAL_NAME_ACCESS_VIEW: 'MODAL_NAME_ACCESS_VIEW',
      MODAL_DESCRIPTTION: 'Representa un medio para compartir vocabulario interno dentro de una organización',
      modalId: 'dp_BusinessGlossary',
      modalName: 'Business Glossary',
      subdomains: [],
      ALL_VALUE: 'TODOS',
      kdomain: 'TODOS',
      ksubdomain: 'TODOS',
      terms: [],
      registers: [],
      tree: [],
      value: ['class1', 'class2'],
      tplToUpdate: {},
      sharedOptions: [{
        text: 'TERMS',
        value: 'TERMS'
      }, {
        text: 'SHARED',
        value: 'SHARED'
      }],
      filterSelected: 'TERMS',
      datos: [],
      wrnng: '',
      cDomain: '',
      selectOrganization: [],
      cRoles: [],
      cEmail: '',
      MyDomain: '',
      Q_DEFAULT: TAG_QUERIES.TABLES_RELATED_BT,
      filterterms: [],
      filter: '',
      isLoading: false,
      showShared: false,
      showTree: false,
      filter_enabled: false,
      // true,
      text_filter: '',
      text_filter_: '',
      pagination: {
        current: 1,
        limit: 10,
        total: 0
      },
      key_view: 1,
      key_edit: 1
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['isDomainItc', 'selectDomain', 'selectSubdomain'])), mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    relationshipField: function relationshipField() {
      /*return [
        {value: 'domain', text: this.traductor('tablas.domain'), class: 'titulo'},
        {value: 'subdomain', text: this.traductor('filtros.subdomain'), class: 'titulo'},
        {value: 'business_term', text: this.traductor('tablas.bterm'), class: 'titulo', sortable: true},
        {value: 'definition', text: this.traductor('tablas.definition'), class: 'titulo'},
        {value: 'listval', text: this.traductor('tablas.values'), class: 'titulo'},
        {value: 'listtag', text: this.traductor('tablas.tags'), class: 'titulo'},
        {value: 'also_known_as', text: this.traductor('tablas.aka'),class: 'titulo'},
        {value: 'accountable', text: this.traductor('tablas.accountable'), class: 'titulo', sortable: true},
        {
          value: 'critical',
          text: this.traductor('tablas.critical'),
          class: 'titulo', sortable: true, sortByFormatted: true},
        {value: 'vstatus', text: this.traductor('tablas.status'), class: 'titulo'},
        { thStyle: { width: '100px !important' }, value: 'nav', text: this.traductor('tablas.actions'), class: 'titulo'}
      ]*/
      return [{
        value: 'business_term',
        text: this.traductor('tablas.bterm'),
        class: 'titulo',
        sortable: true,
        align: "center"
      }, {
        value: 'definition',
        text: this.traductor('tablas.definition'),
        class: 'titulo'
      }, {
        value: 'domain',
        text: this.traductor('tablas.domain'),
        class: 'titulo',
        align: "center"
      }, {
        value: 'subdomain',
        text: this.traductor('filtros.subdomain'),
        class: 'titulo',
        align: "center"
      }, {
        value: 'vstatus',
        text: this.traductor('tablas.status'),
        class: 'titulo',
        align: "center"
      }, {
        value: 'update_date',
        text: 'Últ. Act.',
        class: 'titulo',
        align: "center"
      }, {
        thStyle: {
          width: '100px !important'
        },
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'titulo',
        align: "center"
      }];
    },
    texts: function texts() {
      return {
        org: this.traductor('filtros.organization'),
        domain: this.traductor('tablas.domain'),
        subdomain: this.traductor('filtros.subdomain'),
        delete_bterm: this.traductor('frases.delete_bterm')
      };
    },
    validUser: function validUser() {
      if (this.cDomain === this.userDomain && (this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD) || this.userHasRole(this.rolesINCA.BUSINESS_DATA_STEWARD))) {
        return false;
      } else {
        return true;
      }
    },
    filterSubdomain: function filterSubdomain() {
      var _this = this;
      var selectbusinessSubdomain = this.selectbusinessSubdomain.filter(function (Subdomain) {
        return Subdomain.domain === _this.kdomain;
      });
      return selectbusinessSubdomain;
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('descripcion.des_business_glossary'),
        disabled: true
      }];
    }
  }),
  created: function created() {
    console.log("aqui es");
    //this.getOrganizations()
    this.cDomain = this.userDomain;
    //this.getSelectFields()
  },
  watch: {
    selectDomain: function selectDomain(newVal) {
      if (newVal && newVal.length) {
        this.getSelectFields();
      }
    },
    selectSubdomain: function selectSubdomain(newVal) {
      if (newVal && newVal.length) {
        this.getSelectFields();
      }
    },
    ksubdomain: function ksubdomain() {
      this.getFilteredTerms(this.filterSelected);
    },
    cDomain: function () {
      var _cDomain = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var allOption, _allOption;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.isLoading = true;
              if (this.cDomain === 'intercorp.com.pe') {
                allOption = this.sharedOptions.find(function (opt) {
                  return opt.value === 'ALL';
                });
                if (!allOption) {
                  this.sharedOptions.unshift({
                    text: 'ALL',
                    value: 'ALL'
                  });
                  this.filterSelected = 'ALL';
                }
              } else {
                _allOption = this.sharedOptions.find(function (opt) {
                  return opt.value === 'ALL';
                });
                if (_allOption) {
                  this.sharedOptions.shift();
                  this.filterSelected = 'TERMS';
                }
              }
              _context.n = 1;
              return this.getSelectFields();
            case 1:
              this.getBusinessTerms().then(function () {
                // Seleccionando el dominio y subdominio con mínimo un término
                var businessTerms = _this2.terms;
                var continueLoop = true;
                var firstKdomain = _this2.UNDEFINED;
                var firstKsubdomain = _this2.UNDEFINED;
                _this2.selectBusinessDomain.every(function (domain) {
                  _this2.selectbusinessSubdomain.filter(function (Subdomain) {
                    return Subdomain.domain === domain.value;
                  }).every(function (subdomain) {
                    var filtered = businessTerms.filter(function (bTerm) {
                      return bTerm.kdomain === domain.value && bTerm.ksubdomain === subdomain.value;
                    });
                    continueLoop = !(filtered.length > 0 && domain.value !== _this2.UNDEFINED && subdomain.value !== _this2.UNDEFINED);
                    if (!continueLoop) {
                      firstKdomain = domain.value;
                      firstKsubdomain = subdomain.value;
                    }
                    return continueLoop;
                  });
                  return continueLoop;
                });
                // this.kdomain = firstKdomain
                // this.ksubdomain = firstKsubdomain
              }).then(function () {
                _this2.getFilteredTerms(_this2.filterSelected);
              }).finally(function () {
                _this2.isLoading = false;
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function cDomain() {
        return _cDomain.apply(this, arguments);
      }
      return cDomain;
    }()
  },
  methods: {
    onDownloadBulk: function onDownloadBulk() {
      var _this3 = this;
      var columns = ['business_term', 'definition', 'domain', 'subdomain', 'status', 'critical', 'values', 'classification', 'accountable', 'also_known_as', 'contains', 'has_a_type', 'is_a_related_term_from', 'is_a_type_of', 'is_calculated_from', 'is_contained_in', 'is_used_to_calculate', 'related_term'];
      var body = [columns.join(';')];
      var termsToDownload = this.selectedTerms.length > 0 ? this.selectedTerms : this.filterterms;
      var _iterator = _createForOfIteratorHelper(termsToDownload),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var term = _step.value;
          var rel = term.relationship || {};
          var resolveNames = function resolveNames(ids) {
            return (ids || []).map(function (id) {
              var found = _this3.terms.find(function (t) {
                return t.kbusiness_term === id;
              });
              return found ? found.business_term : '';
            }).join(',');
          };
          var row = [term.business_term, term.definition, term.domain, term.subdomain, term.status ? 'true' : 'false', term.critical ? 'true' : 'false', (term.values || []).join(','), (term.classification || []).join(','), term.accountable, term.also_known_as, resolveNames(rel.contains), resolveNames(rel.has_a_type), resolveNames(rel.is_a_related_term_from), resolveNames(rel.is_a_type_of), resolveNames(rel.is_calculated_from), resolveNames(rel.is_contained_in), resolveNames(rel.is_used_to_calculate), resolveNames(rel.related_term)];
          body.push(row.join(';'));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var data = body.join('\n');
      var fileName = "bulk_business_terms.csv";
      console.log("data to download", data);
      tasks.saveData(data, fileName);
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getOrganizations: function getOrganizations() {
      var _this4 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        var orgs = response.data;
        orgs.forEach(function (org) {
          _this4.selectOrganization.push(org);
        });
      });
    },
    getSelectFields: function () {
      var _getSelectFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this5 = this;
        var businessDomains, businessSubdomains, data, _yield$Promise$all, _yield$Promise$all2, domainsRes, subdomainsRes, businessDomainsApi, _businessDomains;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.selectBusinessDomain = [];
              this.selectbusinessSubdomain = [];
              if (!(this.cDomain === this.userDomain)) {
                _context2.n = 1;
                break;
              }
              businessDomains = this.baseSelectBusinessDomain.concat(this.selectDomain);
              businessDomains.forEach(function (domain) {
                return _this5.selectBusinessDomain.push(domain);
              });
              businessSubdomains = this.baseSelectbusinessSubdomain.concat(this.selectSubdomain);
              businessSubdomains.forEach(function (subdomain) {
                return _this5.selectbusinessSubdomain.push(subdomain);
              });
              _context2.n = 3;
              break;
            case 1:
              data = {
                domain: this.cDomain
              };
              _context2.n = 2;
              return Promise.all([businessDomainService.getBusinessDomains(data), businessSubdomainService.getBusinessSubdomains(data)]);
            case 2:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              domainsRes = _yield$Promise$all2[0];
              subdomainsRes = _yield$Promise$all2[1];
              businessDomainsApi = domainsRes.data.result.map(function (domain) {
                return {
                  kdomain: domain.kdomain,
                  value: domain.kdomain,
                  text: domain.domain,
                  organization: _this5.cDomain,
                  definition: domain.definition
                };
              });
              _businessDomains = this.baseSelectBusinessDomain.concat(businessDomainsApi);
              _businessDomains.forEach(function (domain) {
                return _this5.selectBusinessDomain.push(domain);
              });
              this.selectbusinessSubdomain = _toConsumableArray(this.baseSelectbusinessSubdomain);
              subdomainsRes.data.result.forEach(function (subdomain) {
                var bDomain = _businessDomains.find(function (d) {
                  return d.kdomain === subdomain.kdomain;
                });
                _this5.selectbusinessSubdomain.push({
                  domain: bDomain.value,
                  domain_text: bDomain.text,
                  value: subdomain.ksubdomain,
                  text: subdomain.subdomain,
                  definition: subdomain.definition
                });
              });
            case 3:
              // ✅ ahora sí llega aquí en AMBOS casos
              if (!this.selectBusinessDomain.find(function (o) {
                return o.value === _this5.ALL_VALUE;
              })) {
                this.selectBusinessDomain.unshift({
                  value: this.ALL_VALUE,
                  text: this.ALL_VALUE
                });
              }
              if (!this.selectbusinessSubdomain.find(function (o) {
                return o.value === _this5.ALL_VALUE;
              })) {
                this.selectbusinessSubdomain.unshift({
                  domain: this.ALL_VALUE,
                  value: this.ALL_VALUE,
                  text: this.ALL_VALUE
                });
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getSelectFields() {
        return _getSelectFields.apply(this, arguments);
      }
      return getSelectFields;
    }(),
    getBusinessTerms: function getBusinessTerms() {
      var _this6 = this;
      this.terms = [];
      var data = {
        domain: this.cDomain
      };
      return businessTermService.getBusinessTerms(data).then(function (response) {
        _this6.terms = response.data.result.map(function (term) {
          var kdomainTerm = _this6.UNDEFINED;
          var domainTerm = _this6.UNDEFINED;
          var ksubdomainTerm = _this6.UNDEFINED;
          var subdomainTerm = _this6.UNDEFINED;
          var subdomain = _this6.selectbusinessSubdomain.find(function (item) {
            return item.value === term.ksubdomain;
          });
          //console.log(subdomain)
          if (subdomain) {
            kdomainTerm = subdomain.domain;
            domainTerm = subdomain.domain_text;
            ksubdomainTerm = subdomain.value;
            subdomainTerm = subdomain.text;
          }
          return _objectSpread(_objectSpread({}, term), {}, {
            kdomain: kdomainTerm,
            domain: domainTerm,
            subdomain: subdomainTerm,
            ksubdomain: ksubdomainTerm,
            bdomain: _this6.cDomain
          });
        });
        console.log("this termsasd", _this6.terms);
      });
    },
    getFilteredTerms: function getFilteredTerms(value) {
      var _this7 = this;
      var byDomain = function byDomain(t) {
        return _this7.kdomain === _this7.ALL_VALUE || t.kdomain === _this7.kdomain;
      };
      var bySub = function bySub(t) {
        return _this7.ksubdomain === _this7.ALL_VALUE || t.ksubdomain === _this7.ksubdomain;
      };
      switch (value) {
        case 'SHARED':
          this.filterterms = this.terms.filter(function (t) {
            return t.shared === true && byDomain(t) && bySub(t);
          });
          this.showShared = true;
          break;
        case 'ALL':
          this.filterterms = this.terms.filter(function (t) {
            return byDomain(t) && bySub(t);
          });
          this.showShared = false;
          break;
        case 'TERMS':
        default:
          this.filterterms = this.terms.filter(function (t) {
            return !t.shared && byDomain(t) && bySub(t);
          });
          this.showShared = false;
          break;
      }
    },
    onConfirmDeleteBusinessTerm: function onConfirmDeleteBusinessTerm(confirm) {
      var _this8 = this;
      if (!confirm) return this.$refs.dialogConfirmation.onClose();
      var params = {
        email: this.userEmail,
        domain: this.userDomain,
        kbusiness_term: this.kbusiness_termDel,
        business_domain: this.kbusiness_termDel_domain || '',
        business_subdomain: this.kbusiness_termDel_subdomain
      };
      this.isLoading = true;
      businessTermService.deleteBusinessTerm(params).then(function () {
        _this8.terms = _this8.terms.filter(function (t) {
          return t.kbusiness_term !== _this8.kbusiness_termDel;
        });
        _this8.getFilteredTerms(_this8.filterSelected);
        tasks.toast.success('Deleted successfully');
      }).catch(function () {
        tasks.toast.error('Delete failed. Try again.');
      }).finally(function () {
        _this8.isLoading = false;
        _this8.$refs.dialogConfirmation.onClose();
      });
    },
    onCloseDeleteModal: function onCloseDeleteModal(event) {
      //this.$refs['delterm-modal'].hide()
      this.$refs['dialogConfirmation'].onClose();
    },
    onSubmitBusinessTerm: function onSubmitBusinessTerm(validate, fresponse) {
      var _this9 = this;
      this.getBusinessTerms().then(function () {
        //this.$bvModal.hide(this.MODAL_NAME_ACCESS)
        _this9.$refs[_this9.MODAL_NAME_ACCESS].onClose();
      });
    },
    openEditTpl: function openEditTpl(item, type) {
      // get template fields
      this.tplToUpdate = {
        item: item,
        type: type,
        validate: false
      };
      this.key_edit += 1;
      //this.$bvModal.show(this.MODAL_NAME_ACCESS)
      this.$refs[this.MODAL_NAME_ACCESS].onOpen();
    },
    viewItem: function viewItem(item) {
      // get template fields
      this.tplToUpdate = {
        item: item,
        type: 'view',
        validate: false
      };
      this.key_view += 1;
      //this.$bvModal.show(this.MODAL_NAME_ACCESS)
      this.$refs[this.MODAL_NAME_ACCESS_VIEW].onOpen();
    },
    assignDelBterm: function assignDelBterm(item) {
      this.kbusiness_termDel = item.kbusiness_term;
      this.kbusiness_termDel_name = item.business_term;
      this.kbusiness_termDel_domain = item.domain;
      this.kbusiness_termDel_subdomain = item.subdomain;
      this.$refs['dialogConfirmation'].onOpen();
    },
    onDownload: function onDownload() {
      var columns = ['bdomain', 'accountable', 'update_date', 'also_known_as', 'kdomain', 'domain', 'ksubdomain', 'subdomain', 'type', 'kbusiness_term', 'business_term', 'definition', 'status', 'critical', 'values', 'classification', 'related_objects', 'contains', 'has_a_type', 'is_a_related_term_from', 'is_a_type_of', 'is_calculated_from', 'is_contained_in', 'is_used_to_calculate', 'related_term'];
      var body = [columns.join(';')];
      var x, y, contains, has_a_type, is_used_to_calculate, related_term, is_contained_in, idxTerm, is_a_related_term_from, is_a_type_of, is_calculated_from;
      var row1 = [];

      // ✅ variable local, sin "this"
      var termsToDownload = this.selectedTerms.length > 0 ? this.selectedTerms : this.filterterms;
      var number_terms = this.checkLength(termsToDownload);
      for (x = 0; x < number_terms; x++) {
        contains = [];
        has_a_type = [];
        is_used_to_calculate = [];
        related_term = [];
        is_contained_in = [];
        is_a_related_term_from = [];
        is_a_type_of = [];
        is_calculated_from = [];

        // ✅ termsToDownload[x] para iterar, this.terms para resolver relaciones
        var number_contains = this.checkLength(termsToDownload[x].relationship.contains);
        console.log("revisar este", termsToDownload[x]);
        for (y = 0; y < number_contains; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.contains[y];
          });
          contains.push(this.terms[idxTerm].business_term);
        }
        var number_has_a_type = this.checkLength(termsToDownload[x].relationship.has_a_type);
        for (y = 0; y < number_has_a_type; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.has_a_type[y];
          });
          has_a_type.push(this.terms[idxTerm].business_term);
        }
        var number_used_calculate = this.checkLength(termsToDownload[x].relationship.is_used_to_calculate);
        for (y = 0; y < number_used_calculate; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.is_used_to_calculate[y];
          });
          is_used_to_calculate.push(this.terms[idxTerm].business_term);
        }
        var number_related_term = this.checkLength(termsToDownload[x].relationship.related_term);
        for (y = 0; y < number_related_term; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.related_term[y];
          });
          related_term.push(this.terms[idxTerm].business_term);
        }
        var number_contained = this.checkLength(termsToDownload[x].relationship.is_contained_in);
        for (y = 0; y < number_contained; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.is_contained_in[y];
          });
          is_contained_in.push(this.terms[idxTerm].business_term);
        }
        var number_related = this.checkLength(termsToDownload[x].relationship.is_a_related_term_from);
        for (y = 0; y < number_related; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            console.log("revisar este", key.kbusiness_term, termsToDownload[x].relationship.is_a_related_term_from[y]);
            return key.kbusiness_term === termsToDownload[x].relationship.is_a_related_term_from[y];
          });
          is_a_related_term_from.push(this.terms[idxTerm].business_term);
        }
        var number_type = this.checkLength(termsToDownload[x].relationship.is_a_type_of);
        for (y = 0; y < number_type; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.is_a_type_of[y];
          });
          is_a_type_of.push(this.terms[idxTerm].business_term);
        }
        var number_calculated = this.checkLength(termsToDownload[x].relationship.is_calculated_from);
        for (y = 0; y < number_calculated; y++) {
          idxTerm = this.terms.findIndex(function (key) {
            return key.kbusiness_term === termsToDownload[x].relationship.is_calculated_from[y];
          });
          is_calculated_from.push(this.terms[idxTerm].business_term);
        }

        // ✅ todo usa termsToDownload[x]
        row1.push({
          bdomain: this.cDomain,
          accountable: termsToDownload[x].accountable,
          update_date: termsToDownload[x].update_date,
          also_known_as: termsToDownload[x].also_known_as,
          kdomain: termsToDownload[x].kdomain,
          domain: termsToDownload[x].domain,
          ksubdomain: termsToDownload[x].ksubdomain,
          subdomain: termsToDownload[x].subdomain,
          type: termsToDownload[x].type,
          kbusiness_term: termsToDownload[x].kbusiness_term,
          business_term: termsToDownload[x].business_term,
          definition: termsToDownload[x].definition,
          status: termsToDownload[x].status,
          critical: termsToDownload[x].critical,
          values: termsToDownload[x].values.toString(),
          classification: termsToDownload[x].classification.toString(),
          related_objects: termsToDownload[x].related_objects.toString(),
          contains: contains.toString(),
          has_a_type: has_a_type.toString(),
          is_a_related_term_from: is_a_related_term_from.toString(),
          is_a_type_of: is_a_type_of.toString(),
          is_calculated_from: is_calculated_from.toString(),
          is_contained_in: is_contained_in.toString(),
          is_used_to_calculate: is_used_to_calculate.toString(),
          related_term: related_term.toString()
        });
      }
      var row = [];
      for (var _i = 0, _row = row1; _i < _row.length; _i++) {
        var record = _row[_i];
        var _iterator2 = _createForOfIteratorHelper(columns),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var column = _step2.value;
            row.push(record[column]);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        row = row.join(';');
        body.push(row);
        row = [];
      }
      var data = body.join('\n');
      var fileName = "".concat(this.modalId, ".csv");
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.DOWNLOAD_GLOSSARY,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      tasks.saveData(data, fileName);
    },
    checkLength: function checkLength(array) {
      return array && array.length ? array.length : 0;
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      this.text_filter_ = this.text_filter;
    },
    onLimpiar: function onLimpiar() {
      this.text_filter_ = '';
      this.text_filter = '';
      this.selectedTerms = [];
      this.getBusinessTerms();
    },
    openRelation: function openRelation(item) {
      var mode = this.validUser ? 'view' : 'edit';
      this.$router.push({
        name: 'BusinessTerm',
        params: {
          id: item.kbusiness_term,
          domain: item.bdomain
        },
        query: {
          mode: mode
        }
      });
    },
    getDomainDef: function getDomainDef(domain) {
      console.log("test", this.selectBusinessDomain);
      console.log("test", domain);
      var result = this.selectBusinessDomain.find(function (obj) {
        return obj.text === domain;
      });
      console.log("test_aqui", result);
      return result ? result.definition : "No hay definición";
    },
    //terminar
    getSubDomainDef: function getSubDomainDef(domain) {
      var result = this.selectBusinessDomain.find(function (obj) {
        return obj.text === domain;
      });
      return result ? result.definition : "No hay definición";
    }
  }
};